import { render } from "./VisualizacaoOsTablets.vue?vue&type=template&id=194734ce&scoped=true"
import script from "./VisualizacaoOsTablets.vue?vue&type=script&lang=js"
export * from "./VisualizacaoOsTablets.vue?vue&type=script&lang=js"

import "./VisualizacaoOsTablets.vue?vue&type=style&index=0&id=194734ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-194734ce"]])

export default __exports__